import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../services/api-services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-drug-list-pop-up',
  templateUrl: './drug-list-pop-up.component.html',
  styleUrls: ['./drug-list-pop-up.component.scss']
})
export class DrugListPopUpComponent {
  drugList: any[] = [];
  progress_spinner = true;
  user_id: any;
  message_id: any;
  showOldPrescriptions = false;
  showNewPrescriptions = false;
  slhPrescription = false;

  constructor(
    public dialogRef: MatDialogRef<DrugListPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public userService: UserService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.progress_spinner = true;
    this.user_id = 0;
    this.message_id = this.data?.item?.rc_message_id;
    if (this.data?.item?.auth_client_id > 0 && this.data?.item?.client?.id > 1) {
      this.slhPrescription = true;
      this.drugList = this.data?.item?.receipt?.prescriptions || [];
      this.progress_spinner = false;
    } else {
      if (this.user_id > 0) {
        this.showOldPrescriptions = true;
        this.getDrugListUserId();
      } else {
        this.showNewPrescriptions = true;
        this.getDrugListMessageId();
      }
    }
  }

  getDrugListUserId() {
    const payload = {
      user_id: this.user_id ? this.user_id : 0,
      message_id: this.message_id ? this.message_id : 0
    };
    this.userService.get_drug_list(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          const list = res?.body?.data || [];
          this.drugList = list.map((d: any) => ({
            id: d.id,
            renew_refill_id: d.renew_refill_id,
            drug_name: d.drug_name,
            rxNum: d.drugs_ai?.rxNum || '',
            dosage: d.drugs_ai?.dosage || '',
            repeats: d.drugs_ai?.repeats || '',
            drugName: d.drugs_ai?.drugName || '',
            quantity: d.drugs_ai?.quantity || '',
            strength: d.drugs_ai?.strength || '',
            dosageForm: d.drugs_ai?.dosageForm || '',
            instructions: d.drugs_ai?.instructions || '',
            editMode: false,
            original: { ...d.drugs_ai }
          }));
          this.progress_spinner = false;
        } else {
          this.toastr.error('Failed to fetch drug list');
          this.dialogRef.close();
          this.progress_spinner = false;
        }
      },
      error: (err) => {
        console.error('Error fetching drug list', err);
        this.dialogRef.close();
        this.progress_spinner = false;
      }
    });
  }

  enableRowEdit(item: any) {
    item.editMode = true;
    item.original = { ...item }; // keep a copy of old values
  }

  cancelRowEdit(item: any) {
    Object.assign(item, item.original); // restore old values
    item.editMode = false;
  }

  confirmRowEdit(item: any) {
    item.saving = true;
    const payload = {
      renew_refill_detail_id: item.id,
      renew_refill_id: item.renew_refill_id,
      drug_name: item.drug_name,
      rx_num: item.rxNum || '',
      dosage: item.dosage || '',
      repeats: item.repeats || '',
      quantity: item.quantity || '',
      strength: item.strength || '',
      dosage_form: item.dosageForm || '',
      instructions: item.instructions || ''
    };
    this.userService.updateDrug(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          item.editMode = false;   // success hone ke baad hi band karo
          item.saving = false;
          this.toastr.success('Drug updated successfully');
        }
      },
      error: (err) => {
        console.error('Error updating drug:', err);
        this.cancelRowEdit(item); // rollback
        item.saving = false;
      }
    });
  }

  getDrugListMessageId() {
    const payload = {
      user_id: this.user_id || 0,
      message_id: this.message_id || 0
    };
    this.userService.get_drug_list(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          const list = res.body.data || [];
          this.drugList = list.map((d: any) => ({
            id: d.id,
            prescription_id: d.prescription_id,
            message_id: d.message_id,
            rxNum: d.rx_num || '',
            drugName: d.drug_name || '',
            dosage: d.dosage || '',
            repeats: d.repeats || '',
            quantity: d.quantity || '',
            strength: d.strength || '',
            dosageForm: d.dosage_form || '',
            instructions: d.instructions || '',
            status: d.status,
            created_at: d.created_at,
            updated_at: d.updated_at,
            editMode: false,
            saving: false,
            original: { ...d }
          }));
          this.progress_spinner = false;
        } else {
          this.toastr.error('Failed to fetch drug list');
          this.dialogRef.close();
          this.progress_spinner = false;
        }
      },
      error: (err) => {
        console.error('Error fetching drug list', err);
        this.dialogRef.close();
        this.progress_spinner = false;
      }
    });
  }


  enableRowEditNewPres(item: any) {
    item.editMode = true;
    item.original = { ...item };
  }

  cancelRowEditNewPres(item: any) {
    Object.assign(item, item.original);
    item.editMode = false;
  }

  confirmRowEditNewPres(item: any) {
    item.saving = true;
    const payload = {
      fax_drug_id: item.id,
      message_id: this.message_id || 0,
      prescription_id: item.prescription_id,
      rx_num: item.rxNum || '',
      drug_name: item.drugName || '',
      dosage: item.dosage || '',
      repeats: item.repeats || '',
      quantity: item.quantity || '',
      strength: item.strength || '',
      dosage_form: item.dosageForm || '',
      instructions: item.instructions || ''
    };

    this.userService.updateDrug(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          item.saving = false;
          item.editMode = false;
          this.toastr.success('Drug updated successfully');
        } else {
          console.error('Error updating drug:', res?.body?.message);
          this.toastr.error(res?.body?.message);
          this.cancelRowEditNewPres(item);
          item.saving = false;
        }
      },
      error: (err) => {
        console.error('Error updating drug:', err);
        this.toastr.error('Update failed');
        this.cancelRowEditNewPres(item);
        item.saving = false;
      }
    });
  }

}
